import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Switch } from 'react-router-dom';
import { AnonymousRoute, AuthenticatedRoute } from './../components/routes';
import { RoleDefinitions } from './../utilities/roles';
import { isOnboardingPage } from '../utilities/navigation';
import { withRole, withRequirements } from './../components/hoc';
import { SideMenu } from './../components/menus';
import { SnackbarContainer } from '../components/snackbar';
import Loader from './../components/loader';
import Header from './../components/header';
import RoleSelector from '../components/roleSelector';
import SignatureDialog from '../components/signature/signatureDialog';
import * as pages from './../pages';
// import Usersnap from '../components/usersnap';
import Drift from '../components/drift';

import 'react-toastify/dist/ReactToastify.css';
import { bindActionCreators } from 'redux';
import { setMenuLabelOfLocation } from '../reducers/tenants';
import VersionPoller from '../components/versionPoller';

class Router extends React.Component {
    constructor(props) {
        super(props);

        this.getComponentArrangement = this.getComponentArrangement.bind(this);
    }

    render() {
        const { isAuthenticated, role, navigablePages, setMenuLabelOfLocation, requirements, details, jobs } = this.props;
        const job = jobs && jobs.length ? jobs[0] : {};
        const auth = { isAuthenticated, role, navigablePages, setMenuLabelOfLocation, requirements, details, job };
        const { Admin, AdminFinance, AdminHumanResources, Client, ClientHiringManager, ClientTimesheetApprover, Contractor, Witness } = RoleDefinitions;
        const ClientAll = [Client, ClientHiringManager, ClientTimesheetApprover];
        const { header, menu, content } = this.getComponentArrangement();

        return (
            <div>
                <Header {...header} showHamburgerMenu={menu} />
                <VersionPoller />
                <main>
                    {menu ? <SideMenu size={menu} /> : null}

                    <div className={content}>
                        <Switch>
                            <AnonymousRoute path="/login" component={pages.AccountPage} form="login" exclusively {...auth} />
                            <AnonymousRoute path="/forgot" component={pages.AccountPage} form="forgot" exclusively {...auth} />
                            <AnonymousRoute path="/reset" component={pages.AccountPage} form="reset" exclusively {...auth} />
                            <AnonymousRoute path="/accept-invite" component={pages.AccountPage} form="accept-invite" exclusively {...auth} />

                            <AnonymousRoute path="/about" component={pages.AboutPage} {...auth} />
                            <AnonymousRoute path="/blank" component={pages.BlankPage} {...auth} />

                            <AuthenticatedRoute path="/addresses" exact={true} component={pages.AddressesPage} {...auth} tenants={[Client, Contractor]} />
                            <AuthenticatedRoute path="/address/:id" exact={true} component={pages.AddressPage} {...auth} tenants={[Client, Contractor]} />
                            <AuthenticatedRoute path="/approvals" exact={true} component={pages.ApprovalsPage} {...auth} tenants={[Admin]} />
                            <AuthenticatedRoute path="/approval/:id" exact={true} component={pages.ApprovalPage} {...auth} tenants={[Admin]} />
                            <AuthenticatedRoute path="/banking" component={pages.BankingPage} {...auth} tenants={Client} />
                            <AuthenticatedRoute path="/benefits" component={pages.BenefitsPage} {...auth} tenants={Contractor} />
                            <AuthenticatedRoute path="/client/:id" exact={true} component={pages.ClientPage} {...auth} tenants={Admin} />
                            <AuthenticatedRoute path="/clients" component={pages.ClientsPage} {...auth} tenants={[Admin, AdminFinance, AdminHumanResources]} />
                            <AuthenticatedRoute path="/company" component={pages.CompanyPage} {...auth} tenants={Client} />
                            <AuthenticatedRoute path="/dashboard" component={pages.DashboardPage} {...auth} />
                            <AuthenticatedRoute path="/documents" component={pages.DocumentsPage} {...auth} />
                            <AuthenticatedRoute path="/paystubs" component={pages.PayStubsPage} {...auth} tenants={Contractor} />
                            <AuthenticatedRoute path="/paydue/:payDueId" component={pages.PayDuePage} {...auth} tenants={[Admin, Contractor]} />
                            <AuthenticatedRoute path="/expenses" component={pages.ExpensesPage} {...auth} tenants={[Client, Contractor]} />
                            <AuthenticatedRoute path="/leaves" component={pages.LeavesPage} {...auth} tenants={[Client, Contractor]} />
                            <AuthenticatedRoute path="/messages" component={pages.MessagesPage} {...auth} />
                            <AuthenticatedRoute path="/payments" component={pages.PaymentsPage} {...auth} tenants={Contractor} />
                            <AuthenticatedRoute path="/onboarding" component={pages.OnboardingPage} {...auth} tenants={[Admin, Client, Contractor, Witness]} />
                            <AuthenticatedRoute path="/positions" component={pages.PositionsPage} {...auth} tenants={[Client, ClientHiringManager]} />
                            <AuthenticatedRoute path="/position/:id" component={pages.PositionPage} {...auth} tenants={[Client, ClientHiringManager]} />
                            <AuthenticatedRoute path="/profile" component={pages.ProfilePage} {...auth} />
                            <AuthenticatedRoute path="/reports" component={pages.ReportsPage} {...auth} tenants={Client} />
                            <AuthenticatedRoute path="/time" component={pages.TimeKeepingPage} {...auth} tenants={[Admin, ...ClientAll, Contractor]} />
                            <AuthenticatedRoute path="/users" component={pages.UsersPage} {...auth} tenants={[Admin, Client]} />
                            <AuthenticatedRoute path="/invoice/:invoiceId" component={pages.InvoicePage} {...auth} tenants={[Admin, Client]} />
                            <AuthenticatedRoute path="/invoices" component={pages.InvoicesPage} {...auth} tenants={[Admin, Client]} />
                            <AuthenticatedRoute path="/payrolls" component={pages.PayrollsPage} {...auth} tenants={[Admin, Client]} />
                            <AuthenticatedRoute path="/user/:refType/:refId/:userId" component={pages.UserPage} {...auth} tenants={[Admin, Client]} />
                            <AuthenticatedRoute path="/projects" component={pages.ProjectsPage} {...auth} tenants={Client} />

                            <AuthenticatedRoute
                                path="/worker/:client/:contractor/:worker"
                                exact={true}
                                component={pages.WorkerPage}
                                {...auth}
                                tenants={[Admin, Client, ClientHiringManager]}
                            />
                            <AuthenticatedRoute
                                path="/worker/:client/:contractor/:worker/:tab"
                                exact={true}
                                component={pages.WorkerPage}
                                {...auth}
                                tenants={[Admin, Client, ClientHiringManager]}
                            />

                            <AuthenticatedRoute path="/settings" component={pages.SettingsPage} {...auth} />
                            <AuthenticatedRoute path="/help" component={pages.HelpPage} {...auth} />
                            <AuthenticatedRoute path="/" component={pages.DashboardPage} {...auth} />
                        </Switch>
                    </div>
                </main>

                <SignatureDialog />
                <RoleSelector connected={true} />
                <SnackbarContainer />
                <Loader />
                {/* <Usersnap /> */}
                {isAuthenticated && <Drift />}
            </div>
        );
    }

    getComponentArrangement() {
        const { isAuthenticated, location } = this.props;
        const idHelper = location.pathname.replace('/', 'z');

        if (isAuthenticated) {
            if (isOnboardingPage(location)) {
                return {
                    header: { size: 'col-sm-8 col-sm-offset-2 col-xs-12', menu: true, notifications: false },
                    menu: undefined,
                    content: 'col-sm-8 col-sm-offset-2 col-xs-12'
                };
            }

            return {
                header: { size: 'col-xs-12', id: idHelper },
                menu: 'col-lg-2 col-md-2 col-sm-3 col-xs-12',
                content: 'col-lg-10 col-md-10 col-sm-9 col-xs-12'
            };
        }

        return {
            header: { size: 'col-xs-12' },
            menu: undefined,
            content: 'col-xs-12'
        };
    }
}

Router.defaultProps = {
    isAuthenticated: false,
    role: undefined
};

Router.propTypes = {
    isAuthenticated: PropTypes.bool,
    role: PropTypes.object
};

const mapStateToProps = state => ({
    isAuthenticated: state.identity.isAuthenticated,
    details: state.identity.details,
    navigablePages: state.tenants ? state.tenants.menu : undefined,
    requirements: state.tenants ? state.tenants.requirements : undefined,
    jobs: state.jobs ? state.jobs.list : undefined
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            setMenuLabelOfLocation
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(withRequirements(withRole(Router)));



// WEBPACK FOOTER //
// ./src/router/index.jsx